import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Защищённый маршрут: перенаправляет неавторизованных пользователей на страницу входа.
// Если у пользователя не заполнен telegram_username — перенаправляет на профиль.
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Если нет telegram — направляем заполнить профиль (но не зацикливаем на /profile)
  if (!user?.telegram_username && location.pathname !== '/profile') {
    return <Navigate to="/profile" replace />;
  }

  return children;
};

export default ProtectedRoute;
